import ApiService from '@zola-helpers/client/dist/es/http/api';
import { toastsActions } from '@zola-helpers/client/dist/es/redux/toasts';
import * as ActionType from './types/CartActionTypes';

function requestSize() {
  return {
    type: ActionType.REQUEST_SIZE,
  };
}

function receiveSize(response) {
  return {
    type: ActionType.RECEIVE_SIZE,
    payload: response.data && response.data.items.length, // temporary
  };
}

function requestCart() {
  return {
    type: ActionType.REQUEST_CART,
  };
}

function receiveCart(response) {
  return {
    type: ActionType.RECEIVE_CART,
    payload: response.data,
  };
}

export function unloadCart() {
  return {
    type: ActionType.UNLOAD_CART,
  };
}

export function resetCart() {
  return {
    type: ActionType.RESET_CART,
  };
}

// Temporary
export function getCartSize() {
  return (dispatch) => {
    dispatch(requestSize());

    return ApiService.get(`/website-nav/web-api/v1/cart`).then((json) =>
      dispatch(receiveSize(json))
    );
  };
}

export function getCart() {
  return (dispatch) => {
    dispatch(requestCart());

    return ApiService.get(`/website-nav/web-api/v1/cart`).then((json) =>
      dispatch(receiveCart(json))
    );
  };
}

export function removeItem(id) {
  return (dispatch) => {
    dispatch(requestCart());

    return ApiService.delete(`/website-nav/web-api/v1/cart/item/id/${id}`).then((json) =>
      dispatch(receiveCart(json))
    );
  };
}

export function removeItems(itemIds) {
  return (dispatch) => {
    dispatch(requestCart());

    return ApiService.post(`/website-nav/web-api/v1/cart/items`, { itemIds }).then((json) =>
      dispatch(receiveCart(json))
    );
  };
}

export function updateItemQuantity(id, quantity) {
  return (dispatch) => {
    dispatch(requestCart());

    return ApiService.put(`/website-nav/web-api/v1/cart/item/id/${id}`, { quantity }).then(
      (json) => {
        if (json && json.data.errorMessage) {
          const error = new Error(json.data.errorMessage);
          error.response = json.data;
          dispatch(toastsActions.negative({ headline: json.data.errorMessage }));
          dispatch({
            type: ActionType.RECEIVE_CART,
            payload: json.data.cart,
          });
        } else {
          dispatch({
            type: ActionType.RECEIVE_CART,
            payload: json.data.cart,
          });
        }
      }
    );
  };
}
